import React, { memo } from 'react'

export default memo(function Title() {
    return (
        <div className="page-title">
            <h1 className="page-title__title">WE ARE CREAT</h1>
            <h2 className="page-title__subtitle">EMOTIONS</h2>
        </div>
    )
})
